import {NewLimsMaterial} from '@domain/materials'

export const getNewFormLimsMaterial = (): NewLimsMaterial => {
  return {
    id: null,
    code: null,
    name: null
  }
}
